export const TUVIS_MESSAGE_SOURCES = ["desktop", "sidecar", "extension", "slack", "tuvisTeamsApp", "wabaWeb", "archive"] as const;
export type TuvisMessageSource = (typeof TUVIS_MESSAGE_SOURCES)[number];
